import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSign = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.20701 2.08554H11.0313M4.16296 2.38711H2.39416C2.15961 2.38711 1.93466 2.47827 1.7688 2.64052C1.60294 2.80278 1.50977 3.02285 1.50977 3.25232V13.6348C1.50977 13.8643 1.60294 14.0843 1.7688 14.2466C1.93466 14.4088 2.15961 14.5 2.39416 14.5H10.3537C10.5883 14.5 10.8132 14.4088 10.9791 14.2466C11.145 14.0843 11.2381 13.8643 11.2381 13.6348V12.7696M3.87801 6.43351H5.73496M8.47335 11.5377L6.28477 11.8434L6.59725 9.70228L12.2256 4.1961C12.4743 3.95271 12.8118 3.81598 13.1636 3.81598C13.5154 3.81598 13.8529 3.95271 14.1017 4.1961C14.3504 4.43949 14.4902 4.7696 14.4902 5.1138C14.4902 5.458 14.3504 5.78811 14.1017 6.03149L8.47335 11.5377ZM4.23015 1.5H8.76412V3.27424H4.23015V1.5Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSign;
